
import Vue from 'vue';
import QoalaTyped from '../../Icons/QoalaTyped.vue';
import { Padder } from '../../eucalyptus/Spacings';

/**
 * AppBar component.
 *
 * Header of application with extra Toolbar
 */
export default Vue.extend({
  name: 'AppBarEntry',
  components: {
    QoalaTyped,
    Padder
  },
  props: {
    /**
     * The logo of the AppBar.<br />
     * The type is VueComponent.
     */
    logo: {
      type: Object,
      default: () => {}
    },
    /**
     * Enable the right component.
     */
    rightComponent: {
      type: Boolean,
      default: false
    },
    // ToolBar Property
    /**
     * Hide shadow of the AppBar.
     */
    hideShadowbar: {
      type: Boolean,
      default: false
    },
    /**
     * Add additional toolbar in AppBar.
     */
    useToolBar: {
      type: Boolean,
      default: false
    },
    /**
     * Add border to AppBar and Toolbar.
     */
    seperateToolBar: {
      type: Boolean,
      default: false
    }
    // ToolBar Property
  },
  computed: {
    paddingToolBar() {
      return this.useToolBar ? undefined : 'sm';
    }
  },
  methods: {
    handleLogoClick() {
      /**
       * Handle when logo is clicked.
       * @event logo-click
       * @type {function}
       */
      this.$emit('logo-click');
    },
    handleRightClick() {
      /**
       * Handle when Right Component is clicked.
       * @event right-click
       * @type {function}
       */
      this.$emit('right-click');
    },
    handleLeftClick() {
      /**
       * Handle when Left Component is clicked.
       * @event left-click
       * @type {function}
       */
      this.$emit('left-click');
    }
  }
});
